export const GET_REQUEST = 'navbar/GET_REQUEST'
export const GET_SUCCESS = 'navbar/GET_SUCCESS'
export const GET_FAILURE = 'navbar/GET_FAILURE'
export const PUT_REQUEST = 'navbar/PUT_REQUEST'
export const PUT_SUCCESS = 'navbar/PUT_SUCCESS'
export const PUT_FAILURE = 'navbar/PUT_FAILURE'

